/* unplugin-vue-components disabled */import script from "./PublishPlan.vue?vue&type=script&lang=ts&setup=true"
export * from "./PublishPlan.vue?vue&type=script&lang=ts&setup=true"

import "./PublishPlan.vue?vue&type=style&index=0&id=6a8895ec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a8895ec"]])

export default __exports__